import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [expandedFaq, setExpandedFaq] = useState(null);

  const faqs = [
    {
      question: "Can I switch between cloud and desktop solutions?",
      answer: "Yes, you can use both solutions simultaneously or switch between them based on your needs. Many retailers use our cloud solution for multi-store management while maintaining desktop POS for offline reliability at individual locations."
    },
    {
      question: "What happens if my internet goes down with the cloud solution?",
      answer: "Our cloud solution includes a limited offline mode that allows you to continue processing transactions. However, for complete offline reliability, we recommend our Desktop POS solution which operates fully without internet connectivity."
    },
    {
      question: "Is the desktop license billed monthly?",
      answer: "Desktop licenses are billed monthly. Contact our sales team for exact desktop pricing, volume discounts, and billing options. We provide flexible billing plans for single-seat and multi-seat deployments."
    },
    {
      question: "Can I upgrade from Starter to Pro Cloud plan?",
      answer: "Absolutely! You can upgrade your cloud plan at any time. When upgrading, you'll be charged the prorated difference for the remainder of your billing cycle, and your new features will be available immediately."
    },
    {
      question: "Do you offer refunds?",
      answer: "We offer a 14-day money-back guarantee for cloud subscriptions. For desktop licenses, we provide a 7-day trial period before purchase. Once the desktop license is activated, refunds are handled on a case-by-case basis."
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept bank transfers, card payments (Visa, Mastercard), and mobile money payments. For enterprise solutions, we can arrange custom payment terms including invoicing and installment plans."
    },
    {
      question: "Is training included with the purchase?",
      answer: "Starter Cloud includes video tutorials and documentation. Pro Cloud includes one live training session. Desktop POS includes on-site or remote training for up to 3 staff members. Enterprise solutions include comprehensive custom training programs."
    },
    {
      question: "Can I manage multiple stores with the desktop solution?",
      answer: "The Desktop POS is optimized for single-store operations. For multi-store management with centralized control and real-time synchronization, we recommend our Cloud solutions which are specifically designed for this purpose."
    }
  ];

  const toggleFaq = (index) => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };

  return (
    <div>
      <div className="text-center mb-12 md:mb-16">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">
          Frequently Asked Questions
        </h2>
        <p className="font-body text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
          Got questions about our pricing? We've got answers. Can't find what you're looking for? Contact our sales team.
        </p>
      </div>
      <div className="max-w-3xl mx-auto space-y-4">
        {faqs?.map((faq, index) => (
          <div
            key={index}
            className="rounded-xl border border-border bg-card overflow-hidden transition-smooth hover:shadow-purple"
          >
            <button
              onClick={() => toggleFaq(index)}
              className="w-full flex items-center justify-between p-4 md:p-6 transition-smooth hover:bg-muted/30 focus:outline-none"
            >
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground text-left pr-4">
                {faq?.question}
              </h3>
              <Icon
                name={expandedFaq === index ? 'ChevronUp' : 'ChevronDown'}
                size={24}
                color="var(--color-foreground)"
                strokeWidth={2}
                className="flex-shrink-0"
              />
            </button>

            {expandedFaq === index && (
              <div className="px-4 md:px-6 pb-4 md:pb-6 border-t border-border">
                <p className="font-body text-sm md:text-base text-muted-foreground pt-4">
                  {faq?.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;